import React, { useEffect, useState } from "react";
import {  Col,  Form,  Input,  Modal, Row,  Select,  Radio, theme,} from "antd";
import { POST, PATCH } from "../../frameworks/HttpClient";
import { URL_TRUCK } from "../../constants/urls";
import { CHEMICAL } from "../../constants/chemical";
import ErrorMessages from "../../common/ErrorMessages";

export default function ConditionsOfPurchaseModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages , setErrorMessages ] = useState(null);

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const { TextArea } = Input;

  useEffect(() => {
    if (open) {
      form.setFieldsValue(target);
    } else {
      form.resetFields();
    }
  }, [open]);

  const handleOK = async () => {
    setLoading(true);
    try {
      const data = await form.validateFields();
      if (target?.id) {
        await PATCH(`${URL_TRUCK.CONDITIONS_OF_PURCHASE}${target.id}/`, data);
      } else {
        await POST(URL_TRUCK.CONDITIONS_OF_PURCHASE, data);
      }
      await onUpdate();
      onClose();
      form.resetFields();
    } catch (error) { 
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  const allChemicals = [
    ...CHEMICAL.RAW_LATEX,
    ...CHEMICAL.POND,
    ...CHEMICAL.TANK,
  ];

  const uniqueChemicals = allChemicals.reduce((acc, item) => {
    if (!acc.some((existingItem) => existingItem.chemical === item.chemical)) {
      acc.push(item);
    }
    return acc;
  }, []);

  const chemicalOptions = uniqueChemicals.map((item) => ({
    value: item.chemical,
    label: item.chemical,
  }));

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไขเงื่อนไขการรับซื้อ" : "กำหนดเงื่อนไขการรับซื้อ"}
      width={700}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: { backgroundColor: target ? colorWarning : colorSuccess },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages}/>
      <Form form={form} layout="vertical">
        <Row gutter={12} style={{ display: "flex" }}>
          <Col span={8}>
            <Form.Item label="แล็บ" name="chemical" rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}>
              {/* <Select
                placeholder="กรุณาระบุแล็บ"
                value={selectedValue}
                onChange={handleChange}
              >
                {chemicalOptions.map((item) => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select> */}
              <Select
                allowClear
                placeholder="สารเคมี"
                autoComplete="off"
                options={CHEMICAL.RAW_LATEX.map((item) => {
                  return {value : item.chemical}
                })}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="ค่าเริ่มต้น"
              name="min_value"
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Input type="number" placeholder="กรอกค่าเริ่มต้น" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="ค่าสิ้นสุด"
              name="max_value"
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Input type="number" placeholder="กรอกค่าสิ้นสุด" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12} style={{ display: "flex" }}>
          <Col span={12}>
            <Form.Item
              label="ผลการรับซื้อ"
              name="type"
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Radio.Group>
                <Radio value="success">ผ่าน</Radio>
                <Radio value="warning">ผ่าน (มีเงื่อนไข)</Radio>
                <Radio value="danger">ไม่ผ่าน</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="ตัดราคา (บาท/กิโลกรัมยางแห้ง)"
              name="cut_price"
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Input type="number" placeholder="กรอกตัดราคา" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24} style={{ display: "flex" }}>
          <Col span={24}>
            <Form.Item label="รายละเอียด" name="note">
              <TextArea
                placeholder="รายละเอียด"
                autoSize={{ minRows: 3, maxRows: 6 }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
